import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchLessonFiles } from "../../processes/lessonFileProcesses";
import { createMock } from "../../processes/mockProccess";
import {
  currentCourse,
  getCurrentCourseId,
  makeCalculatorButtonEnabled,
  canAccessCourse,
} from "../../selectors/courseSelectors";
import { makeHasFiles } from "../../selectors/lessonFileSelectors";
import {
  getCurrentLesson,
  getCurrentLessonId,
  makeIsCommentsEnabled,
} from "../../selectors/lessonSelectors";
import { getFlattenedLessonQuestions } from "../../selectors/lessonQuestionSelectors";
import LessonActions from "./LessonActions";

function LessonActionsContainer(props) {
  const { dispatch, lesson, currentCourseId } = props;
  const [loadingMock, setLoadingMock] = useState(false);
  const [openCalculator, setOpenCalculator] = useState(false);
  const [activeTab, setActiveTab] = useState("content");
  const activeTabHandler = useCallback(
    (tab) => {
      setActiveTab(tab);
    },
    [setActiveTab]
  );
  const toogleCalculator = useCallback(
    () => setOpenCalculator(!openCalculator),
    [openCalculator]
  );

  useEffect(() => {
    fetchLessonFiles(dispatch, currentCourseId, lesson?.id);
  }, [dispatch, currentCourseId, lesson?.id]);

  const createMockHandler = useCallback(() => {
    setLoadingMock(true);
    createMock(
      { mockTemplateId: lesson?.mockTemplateId, exam: true },
      dispatch
    ).then(() => {
      setLoadingMock(false);
    });
  }, [dispatch, lesson?.mockTemplateId]);

  const tabControlRef = props.tabControlRef || React.useRef(null);

  return (
    <LessonActions
      ref={tabControlRef}
      createMockHandler={createMockHandler}
      loadingMock={loadingMock}
      activeTab={activeTab}
      activeTabHandler={activeTabHandler}
      openCalculator={openCalculator}
      toogleCalculator={toogleCalculator}
      tabControlRef={tabControlRef}
      {...props}
    />
  );
}

function mapStateToProps(state) {
  const currentLessonId = getCurrentLessonId(state);
  const lesson = getCurrentLesson(state, currentLessonId);
  const flattenedLessonQuestions = getFlattenedLessonQuestions(state);
  const hasQuestions = flattenedLessonQuestions && flattenedLessonQuestions.length > 0;

  return {
    lesson,
    hasFiles: makeHasFiles(state, lesson?.id),
    currentCourseId: getCurrentCourseId(state),
    course: currentCourse(state),
    calculatorEnabled: makeCalculatorButtonEnabled(state),
    commentsEnabled: makeIsCommentsEnabled(state),
    canAccessCourse: canAccessCourse(state, lesson?.courseId),
    hasQuestions,
  };
}

export default connect(mapStateToProps)(LessonActionsContainer);
